import { useState, useEffect } from 'react'
import { ESortOrder } from '../components'
import { useSearchParams } from 'react-router'
import * as lib from '../lib'

export const ACCOUNT_DELETED_LIST_MODAL_SORT_FIELDS = ['id', 'email', 'auth.login', 'extra.keitaroLogin', 'role.name', 'role.extra.isBuyer', 'role.extra.inGroup', 'role.extra.isTeam', 'isActive', 'isFired', 'registeredAt', 'deletedAt'] as const

export type IAccountDeletedSortField = typeof ACCOUNT_DELETED_LIST_MODAL_SORT_FIELDS[number]

type IUseSortAccountDeletedListModal = {
	sortBy: IAccountDeletedSortField;
	setSortBy: (value: (((prevState: IAccountDeletedSortField) => IAccountDeletedSortField) | IAccountDeletedSortField)) => void;
	order: ESortOrder;
	setOrder: (value: (((prevState: ESortOrder) => ESortOrder) | ESortOrder)) => void;
}

const DEFAULT_SORT_BY: IAccountDeletedSortField = 'id'
const DEFAULT_SORT_ORDER: ESortOrder = ESortOrder.desc
export const useSortAccountDeletedListModal = (): IUseSortAccountDeletedListModal => {
	const [searchParams, setSearchParams] = useSearchParams()

	const urlSort = (() => {
		try {
			return lib.sortSearchParams(searchParams.get('s')) ?? []
		} catch (error) {
			console.error(error)
			return []
		}
	})().filter((item) => {
		const sortOrderValues = Object.values(ESortOrder)

		return ACCOUNT_DELETED_LIST_MODAL_SORT_FIELDS.includes(item[0] as IAccountDeletedSortField) && sortOrderValues.includes(item[1] as ESortOrder)
	})

	const [sortBy, setSortBy] = useState<IAccountDeletedSortField>(urlSort?.[0]?.[0] as IAccountDeletedSortField ?? DEFAULT_SORT_BY)
	const [order, setOrder] = useState<ESortOrder>(urlSort?.[0]?.[1] as ESortOrder ?? DEFAULT_SORT_ORDER)
	const [send, setSend] = useState<boolean>(false)
	//console.log('useSortAccountDeletedListModal:: ', { sortUrl: urlSort })

	useEffect(() => {
		if (sortBy && order) {
			setSend(true)

			const newSortStr = lib.sortSetup([[sortBy, order]])

			setSearchParams((prev) => {
				if (order !== ESortOrder.unset) {
					prev.set('s', newSortStr)
				} else {
					prev.delete('s')
				}

				return prev
			})
		}
	}, [sortBy, order])

	return {
		// sort: order !== ESortOrder.unset ? [[sortBy, order]] : [],
		sortBy,
		setSortBy,
		order,
		setOrder
	}
}